import { apiRequest } from "../util/apiUtils";

export const dashboardCount = async (params) => {
  try {
    const res = await apiRequest("get", `dashboard/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const dashboardAddEdit = async (payload) => {
  try {
    const res = await apiRequest(
      payload?.id ? "put" : "post",
      `dashboard/${payload?.id ? "edit" : "add"}`,
      {
        body: payload,
      },
      "multipart/form-data"
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const dashboardDelete = async (payload) => {
  try {
    const res = await apiRequest("delete", `dashboard/delete-all`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const dashboardStatusChange = async (payload) => {
  try {
    const res = await apiRequest("patch", `dashboard/status`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const dashboardCountFront = async (params) => {
  try {
    const res = await apiRequest("get", `dashboard/list-front`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
